// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"503":"a679a8ac","514":"dfee718a","675":"bc8cb976","715":"1ad1ed58","726":"6ee00923"}[chunkId] + ".chunk.js";
};